import React from 'react';
import PropTypes from 'prop-types';
import { FrameWithStickyTitle } from 'components/BrandSlides/BrandSlides';
import { QuadrantChart } from '../QuadrantChart/QuadrantChart';
import { ensureArray } from 'utils/safeArray';

export default function QuadrantSlide({ title, data, accent_color, ...props }) {
  const safeData = ensureArray(data);
  
  return (
    <FrameWithStickyTitle title={title} accentColor={accent_color}>
      <div className="flex flex-col justify-start items-center h-full w-full">
        <QuadrantChart data={safeData} accentColor={accent_color} {...props} />
        
        {/* Disclaimer Footer */}
        <div className="mt-6 pt-3 border-t border-slate-200 w-full">
          <p className="text-[11px] text-slate-400 text-center italic leading-snug">
            Disclaimer: This content is AI-generated for preliminary brainstorming purposes and is subject to further discussion with the IT team.
          </p>
        </div>
      </div>
    </FrameWithStickyTitle>
  );
}

QuadrantSlide.propTypes = {
  title: PropTypes.string,
  data: PropTypes.array.isRequired,
  accent_color: PropTypes.string,
};
